// Book-level urgency counts from any slice of an adviser's who-to-call queue.
// The engine (policy priority-2026.10) ranks urgency over the whole book and
// stamps each item with urgency_basis {book_size, eligible, high_top_pct,
// medium_top_pct}, so the counts follow exactly even from the top 20 rows.
export const urgencyTotalsFromQueue = (queue = []) => {
    const basis = queue.find((item) => item?.breakdown?.urgency_basis)?.breakdown?.urgency_basis;
    if (!basis || !Number.isFinite(Number(basis.book_size))) return null;
    const bookSize = Number(basis.book_size);
    const eligible = Number(basis.eligible || 0);
    const high = Math.min(Math.ceil((bookSize * Number(basis.high_top_pct)) / 100), eligible);
    const top = Math.min(Math.ceil((bookSize * Number(basis.medium_top_pct)) / 100), eligible);
    return { bookSize, high, medium: Math.max(0, top - high) };
};

// One row per adviser for "RM Opportunity Coverage": book size from the
// adviser's customer_count (the page's customer list holds only 200 rows) and
// qualified contacts (HIGH + MEDIUM) from the engine's urgency basis.
export const rmCoverageRows = (whoToCallByRm = [], customers = []) => whoToCallByRm
    .map(({ rm, whoToCall = [] }) => {
        const totals = urgencyTotalsFromQueue(whoToCall);
        const listed = customers.filter((customer) => customer.rm_id === rm.rm_id).length;
        const qualifiedInList = whoToCall.filter((item) => ['high', 'medium']
            .includes(String(item.urgency_level || '').toLowerCase())).length;
        return {
            name: rm.full_name || rm.email || rm.rm_id,
            customers: Number.isFinite(Number(rm.customer_count)) ? Number(rm.customer_count) : listed,
            qualified: totals ? totals.high + totals.medium : qualifiedInList,
        };
    })
    .sort((a, b) => b.qualified - a.qualified)
    .slice(0, 5);
